import type { MerchantPreset } from './types';

/**
 * Eager part of the built-in merchant presets. This stays in the main bundle so
 * hostname resolution and cheap scalar flags (auto-open, cart) are correct on the
 * very first render, before the lazy preset chunk resolves. The lazy modules
 * spread these and add the heavy copy/builders.
 */
const LEGACY_SUGGESTED_ACTIONS = [
  'Find my Shade',
  'Product Question',
  'Return / Exchange',
  'Order Status',
];

export const YSEBEAUTY_STATIC: MerchantPreset = {
  id: 'ysebeauty',
  messageActions: false,
  hostnames: [
    'ysebeauty.com',
    'www.ysebeauty.com',
    'ysebeauty.myshopify.com',
    '.ysebeauty.com',
    'yisebeauty.com',
    'www.yisebeauty.com',
    '.yisebeauty.com',
  ],
  suggestedActions: LEGACY_SUGGESTED_ACTIONS,
  // YSE Beauty storefronts never auto-open on mobile, regardless of `disableOnMobile`.
  autoOpen: { disableOnMobile: true },
  cart: { openCartAfterAdd: true, shopifyStorefront: true },
};

export const NOMAKEUPMAKEUP_STATIC: MerchantPreset = {
  id: 'nomakeupmakeup',
  messageActions: false,
  hostnames: [
    'nomakeupmakeup.com',
    'www.nomakeupmakeup.com',
    'nomakeupmakeup.myshopify.com',
    '.nomakeupmakeup.com',
  ],
  suggestedActions: LEGACY_SUGGESTED_ACTIONS,
  cart: { openCartAfterAdd: false, shopifyStorefront: true },
};

export const STATIC_MERCHANT_PRESETS: Record<string, MerchantPreset> = {
  ysebeauty: YSEBEAUTY_STATIC,
  nomakeupmakeup: NOMAKEUPMAKEUP_STATIC,
};
